import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, ShieldCheck, RefreshCw } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const checkoutUrl = 'https://www.yennilemon.com/cart/44211058212999:1';
  return <section id="final-cta" className="bg-[#F0F5F0] py-20 md:py-32 px-4" data-id="element-70">
      <div className="max-w-4xl mx-auto text-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-72">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-olive mb-8" data-id="element-73">
            Este es tu momento de reconexión
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-warm-gray leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-74">
            <p data-id="element-75">
              Tu cuerpo no está roto. Solo necesita que lo escuches con amor y
              calma. Después de los 40, no necesitas más castigo ni dietas
              extremas.
            </p>
            <p data-id="element-76">
              Necesitas armonía, energía y reconexión contigo misma. Esta guía
              es tu primer paso para recuperar la ligereza que mereces — sin
              prisa, sin culpa, con mucho amor propio.
            </p>
          </div>

          <div className="py-8 mb-12" data-id="element-77">
            <p className="text-2xl md:text-3xl font-heading font-medium text-sage italic" data-id="element-78">
              "Elegir cuidarte no es un lujo.
              <br className="hidden md:block" data-id="element-79" /> Es un acto de amor hacia ti
              misma."
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-card max-w-xl mx-auto mb-10 border border-sage/10" data-id="element-80">
            <div className="flex items-center justify-center gap-4 text-warm-gray mb-2" data-id="element-81">
              <span className="line-through text-xl" data-id="element-82">$199 MXN</span>
              <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-83">
                -50% OFF
              </span>
              <span className="text-4xl font-bold text-olive font-heading" data-id="element-84">
                $99 MXN
              </span>
            </div>
            <p className="text-warm-accent font-bold text-sm mt-2" data-id="element-85">
              ⏰ Precio de lanzamiento — Solo por 3 días
            </p>
          </div>

          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block w-full md:w-auto bg-sage hover:bg-sage-dark text-white font-bold py-5 px-12 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-xl mb-8 text-center" data-id="element-86">
            ✨ Quiero mi guía ahora — $99 MXN
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-olive font-medium" data-id="element-87">
            <span className="flex items-center gap-2" data-id="element-88">
              <Lock className="w-4 h-4 text-sage" data-id="element-89" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-90">
              <Download className="w-4 h-4 text-sage" data-id="element-91" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-2" data-id="element-92">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-93" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-94">
              <RefreshCw className="w-4 h-4 text-sage" data-id="element-95" /> Pago único
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}